import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import { useParams } from 'react-router-dom';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import sections
import HeaderRegionCharacter from 'js/containers/header-region/HeaderRegion.character';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import SvgUnderline from 'js/components/svg/Svg.underline';

// import selectors
import { getSiteMetaData, getCurrentPageData } from 'js/store/app/App.selectors';
import { getCharacterByUrl } from 'js/store/characters/Characters.selectors';
import { BASE_API_URL } from '../constants/App';

import PageNotFound from 'js/page/Page.not_found';

const PageIndividualCharacter = (props) => {
  const params = useParams();

  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.character]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, 'characters');
  });

  const character = useSelector((state) => {
    if (params.id) {
      return getCharacterByUrl(state, params.id);
    }
    return false;
  });

  const { name = '', previousItem = false, nextItem = false, fun_fact = '', fun_fact_image = '' } = character || {};

  useEffect(() => {
    trackPageview({ title: name, path: props.path });
    window.fetch(`${BASE_API_URL}track_character/${character.id}`, {
      method: 'GET',
      headers: {
        'X-Language': window.siteData?.locale ?? 'en_GB',
      },
    });
  }, []);

  if (!character) {
    return <PageNotFound />;
  }

  // grab metadata for the character
  const { meta_title = '', meta_description = '', meta_meta_keywords = '' } = character || {};

  const metaData = {
    ...meta,
    title: meta_title !== null && meta_title !== '' ? meta_title : meta.title,
    description: meta_description !== null && meta_description !== '' ? meta_description : meta.description,
    keywords: meta_meta_keywords !== null && meta_meta_keywords !== '' ? meta_meta_keywords : meta.keywords,
  };

  return (
    <>
      <SiteMetaData {...metaData} />
      <HeaderRegionCharacter data={character} name={name} previousItem={previousItem} nextItem={nextItem} />
      <div className="character-page__fun-fact">
        <div className="container">
          <div className="fun-fact">
            <div className="fun-fact__background">
              {fun_fact_image !== '' && fun_fact_image !== null && (
                <div className="fun-fact__image">
                  <figure>
                    <img src={fun_fact_image} alt={name} />
                  </figure>
                </div>
              )}
              <div className="fun-fact__content">
                <div className="fun-fact__title">
                  <h2>Fact File</h2>
                </div>
                <div className="fun-fact__text wysiwyg" dangerouslySetInnerHTML={{ __html: fun_fact }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageIndividualCharacter;
